import React, { Component, PropTypes, addons } from 'react';
import ClassNames from 'classnames';
import { Styles, Paper, IconButton } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SteelCompass from 'services/SteelCompass';

const { Spacing } = Styles;

const styles = {
  uploadInput: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    opacity: 0,
    cursor: 'pointer',
    width: 48,
    height: 48
  }
};

export default class Controls extends Component {
  static propTypes = {
    encoded: PropTypes.bool,
    menuItems: PropTypes.object
  };

  static defaultProps = {
    encoded: false,
    menuItems: {}
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  constructor() {
    super(...arguments);
    this.state = {
      activeMenu: this.props.defaultMenu || 'default',
      locked: false,
      shown: true,
      progressing: false,
      progress: 0
    };
  }

  show() {
    // this.setState({shown: true});
  }

  hide() {
    // this.setState({shown: false});
  }

  onEditMenu(e) {
    if (this.props.onEditMenu) {
      this.props.onEditMenu();
    }
    this.setState({ locked: true });
  }

  onSettingsMenu(e) {
    if (this.props.onSettingsMenu) {
      this.props.onSettingsMenu();
    }
    this.setState({ locked: true });
  }

  onDefaultMenu(e) {
    if (this.props.onDefaultMenu) {
      this.props.onDefaultMenu();
    }
    this.setState({ locked: false });
  }

  setEdit() {
    this.setState({ locked: true, activeMenu: 'edit' });
  }

  onCancel(e) {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.setState({ locked: false, shown: false, activeMenu: 'default' });
  }

  onSave(e) {
    if (this.props.onSave) {
      this.props.onSave();
      this.setState({ locked: false, shown: false, activeMenu: 'default' });
    }
  }

  onDelete(e) {
    if (this.props.onDelete) {
      this.props.onDelete();
    }
  }

  onSettings() {
    if (this.props.onSettings) {
      this.props.onSettings();
    }
    this.setState({ locked: false, shown: false, activeMenu: 'default' });
  }

  handleFile(e) {
    this.setState({ progress: 0, progressing: true });
    SteelCompass.upload(e.target.files, {
      encoded: this.props.encoded,
      progress: event => {
        if (this.props.onProgress && event) {
          this.props.onProgress(event);
        }
      },
      success: response => {
        this.setState({ progressing: false, amount: 0 });
        if (this.props.onUploadSuccess) {
          this.props.onUploadSuccess(response.data);
        }
      }
    });
  }

  _onTouchTap(payload, e) {
    if (payload.menu) {
      this.setState({ activeMenu: payload.menu });
      let func =
        'on' +
        payload.menu.charAt(0).toUpperCase() +
        payload.menu.slice(1) +
        'Menu';
      if (this[func]) {
        this[func]();
      }
    } else if (typeof payload.onTouchTap === 'string') {
      let func =
        'on' +
        payload.onTouchTap.charAt(0).toUpperCase() +
        payload.onTouchTap.slice(1);
      if (this[func]) {
        this[func]();
      } else if (this.props.handler) {
        this.props.handler(func, payload);
      }
    } else if (typeof payload.onTouchTap === 'function') {
      payload.onTouchTap();
    }
    if (e && e.payload) {
      e.stopPropagation();
    }
  }

  render() {
    const iconButtonStyle = {
      backgroundColor: Colors.Colors.fullWhite
    };
    const iconStyle = {
      color: Colors.Colors.fullBlack
    };
    let menuItems = [];

    this.props.menuItems[this.state.activeMenu].forEach((menuItem, index) => {
      if (menuItem.disabled) {
        return null;
      }
      if (menuItem.attach) {
        let props = {
          type: 'file',
          accept: menuItem.accept
        };
        if (this.props.multiple) {
          props.multiple = 'multiple';
        }
        menuItems.push(
          <div style={{ position: 'relative', cursor: 'pointer' }} key={index}>
            <IconButton
              style={iconButtonStyle}
              iconStyle={iconStyle}
              onTouchTap={this._onTouchTap(this, menuItem)}
            >
              <Icons.FileCloudUpload color={Colors.Colors.fullBlack} />
            </IconButton>
            <input
              onChange={this.handleFile.bind(this)}
              style={styles.uploadInput}
              {...props}
            />
          </div>
        );
      } else {
        menuItems.push(
          <IconButton
            style={iconButtonStyle}
            iconStyle={iconStyle}
            key={index}
            onTouchTap={this._onTouchTap.bind(this, menuItem)}
          >
            {menuItem.icon}
          </IconButton>
        );
      }
    });

    let controls = (
      <div
        className="controls-vertical"
        style={{ position: 'absolute', transition: 'all 0.1s ease' }}
        key={this.state.activeMenu}
      >
        <Paper
          style={{ overflow: 'hidden', margin: Spacing.desktopGutterMini }}
        >
          {menuItems}
        </Paper>
      </div>
    );
    return (
      <CSSTransitionGroup
        transitionName="controls-vertical"
        component="div"
        style={{ position: 'absolute', top: 0, right: 0, bottom: 0 }}
        transitionEnterTimeout={100}
        transitionLeaveTimeout={100}
      >
        {controls}
      </CSSTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Page/Controls.js